import { setRecoil } from 'recoil-nexus';

import myScribeAiState from 'components/practice/charts/ClinicalNote/MyScribeAI/state';

export default () => {
  setRecoil(myScribeAiState.myScribeAILoadingState, true);
};
